import { Org } from '../../../contexts/AuthProvider/types';

export enum OrgsSortBy {
  MEASUREMENTS = 'MEASUREMENTS',
  DEVICES = 'DEVICES',
  NAME = 'NAME',
}

export interface SortableOrgs extends Org {
  measurementCount: number;
  deviceCount: number;
}

export interface IOrgMenuState {
  isMenuOpen: boolean;
  selectedOrg?: string | null;
  isEditName?: boolean;
  isCreateOrg?: boolean;
  isDeleteOrg?: boolean;
}
